"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    items: {
        display: 'flex',
        gridRow: function (props) { return props.gridRow; },
        gridColumn: function (props) { return props.gridColumn; },
        gridColumnSpan: function (props) { return props.gridColumnSpan; },
        msGridRow: function (props) { return props.gridRow; },
        msGridColumn: function (props) { return props.gridColumn; },
        msGridColumnSpan: function (props) { return props.gridColumnSpan; },
    },
};
//# sourceMappingURL=NavigationItems.styles.js.map